export enum COMMENT_TYPES {
  'Comment' = 1,
  'Activity' = 2,
  'Workflow' = 3,
  'UserComment' = 7,
}

export interface IComment {
  id: string;
  createdDate: string;
  text: string | null;
  commentType: COMMENT_TYPES | null;
  textCommentColor: string | null;
  isTextBold: boolean;
  background: string | null;
  name: string | null;
  dealId?: string;
  contactId?: string;
  highlightedText?: string
}

export interface IContactCommentsResponse {
  totalCount: number;
  items: IComment[];
}
